/**
 * NOT loading image when parent/element has visibility: hidden;
 * NB! Only for direct parent !!
 */
lazySizes.cfg.loadHidden = false; // eslint-disable-line

/**
 * Import some components before everything else
 */
import './components/helpers/helpers';
import './components/reset/reset';
import './components/typography/typography';

// require all .js files in components directory excluding admin
const components = require.context('./components/', true, /^\.\/(?!.*admin).*\.js$/);

components.keys().map((key) => {
    const component = components(key);

    if (component.default) {
        module.exports[component.default.name] = component.default;
    }
});
